/* import __COLOCATED_TEMPLATE__ from './edit-button-cell.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import { inject as service } from '@ember/service';

export default Component.extend({
  appService: service(),
  finStandaloneService: service(),
  tagName: 'td',
  classNames: ['table__cell settings__attributes-events__cell'],
  classNameBindings: ['archived:o__archived'],

  attribute: readOnly('row.attribute'),
  app: readOnly('appService.app'),
  archived: readOnly('attribute.archived'),

  isStandaloneSyncedAttributeDuringMigration: computed(
    'attribute.isStandaloneSyncedAttribute',
    'app.isMigratingFromStandaloneToSuite',
    function () {
      return (
        !!this.get('attribute.isStandaloneSyncedAttribute') &&
        !!this.get('app.isMigratingFromStandaloneToSuite')
      );
    },
  ).readOnly(),

  actions: {
    openDetailsView() {
      this.get('tableActions.openDetailsView')(this.row);
    },
  },
});
